module.exports = __webpack_public_path__ + "static/media/019-Kissen_ID_37.cee4700b.mp3";